import NDFL3YearLogic2018 from './NDFL3YearLogic2018';

export default class NDFL3YearLogic2019 extends NDFL3YearLogic2018 {
  name() {
    return '2019';
  }

  showDrugsExpenses() {
    return true;
  }

  showPurchaseMethod(sntsId) {
    const appliedSntsCodes = [10, 70];

    return appliedSntsCodes.includes(sntsId);
  }
}
